import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, AlertController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';

import { AuthProvider } from '../../providers/auth/auth';

@IonicPage()
@Component({
  selector: 'page-forgotten-password',
  templateUrl: 'forgotten-password.html',
})
export class ForgottenPasswordPage {

  email: string;
  err: string;
  loading: boolean;

  constructor(public navCtrl: NavController, public navParams: NavParams, public translate: TranslateService, public loadingCtrl: LoadingController, public alertCtrl: AlertController, public authProvider: AuthProvider) {
    this.email = "";
  }

  passwordReset() {
    let loading = this.loadingCtrl.create({
      content: this.translate.instant('MSG_PLEASE_WAIT')
    });

    loading.present();

    let values = {
      email: this.email
    };

    this.authProvider.forgottenPassword(values)
      .subscribe(
        res => {
          console.log(res);
        },
        error => {
          loading.dismiss();
          let alert = this.alertCtrl.create({
            title: this.translate.instant('MODAL_ERROR_TITLE'),
            subTitle: this.translate.instant('MODAL_ERROR_FORGOTTEN_PASSWORD'),
            buttons: [
              this.translate.instant('BTN_OK')
            ]
          });
          alert.present();
        },
        () => {
          loading.dismiss();
          let alert = this.alertCtrl.create({
            title: this.translate.instant('MODAL_SUCCESS_TITLE'),
            subTitle: this.translate.instant('MODAL_SUCCESS_FORGOTTEN_PASSWORD'),
            buttons: [
              this.translate.instant('BTN_OK')
            ]
          });
          alert.present();
          this.navCtrl.pop();
        }
      );
  }

}



// WEBPACK FOOTER //
// ./src/pages/auth/forgotten-password.ts